<div class="row">
  <div class="col-md-12 grid-margin">
    <div class="card p-2">
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">

          <h5 class="mb-3">Contact Details</h5>
          <div class="row">
            <ng-container *ngFor="let f of contactFieldConfigs; trackBy: trackByFieldKey">
              <div class="col-sm-6">
                <ng-container [ngSwitch]="f.type">
                  <app-text-input
                    *ngSwitchCase="'text'"
                    [label]="f.label" [required]="!!f.required" [control]="ctrl(form, f.key)"
                    [submitted]="isSubmitted" [id]="f.key" [placeholder]="f.placeholder || f.label"
                    [maxlength]="f.maxlength || null" [readonly]="f.readonly || false"
                    [serverError]="f.key === 'phoneNumber' ? phoneError : ''"
                    (keypress)="f.keypress ? f.keypress($event) : true"
                  ></app-text-input>
                  <app-select-input
                    *ngSwitchCase="'select'"
                    [label]="f.label" [required]="!!f.required" [control]="ctrl(form, f.key)"
                    [submitted]="isSubmitted" [items]="f.items || []" [bindLabel]="f.bindLabel || 'text'"
                    [bindValue]="f.bindValue || ''" [placeholder]="'Select ' + f.label" [id]="f.key"
                    [readonly]="f.readonly || false" (change)="f.onChange && f.onChange($event)"
                  ></app-select-input>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="isMerchantEntity">
            <h5 class="mb-3 mt-4">Merchant Details</h5>
            <div class="row">
              <ng-container *ngFor="let f of merchantCommonFieldConfigs; trackBy: trackByFieldKey">
                <div class="col-sm-6" *ngIf="!f.hidden">
                  <ng-container [ngSwitch]="f.type">
                    <app-text-input
                      *ngSwitchCase="'text'"
                      [label]="f.label" [required]="!!f.required" [control]="ctrl(form, f.key)"
                      [submitted]="isSubmitted" [id]="f.key" [maxlength]="f.maxlength || null"
                    ></app-text-input>
                    <app-select-input
                      *ngSwitchCase="'select'"
                      [label]="f.label" [required]="!!f.required" [control]="ctrl(form, f.key)"
                      [submitted]="isSubmitted" [items]="f.items || []" [bindLabel]="f.bindLabel || 'text'"
                      [bindValue]="f.bindValue || ''" [placeholder]="'Select ' + f.label" [id]="f.key"
                      [multiple]="f.multiple || false" [closeOnSelect]="f.closeOnSelect ?? true"
                      [searchable]="f.searchable ?? true"
                      (change)="f.onChange && f.onChange($event)"
                    ></app-select-input>
                  </ng-container>
                </div>
              </ng-container>
            </div>

            <div class="row mt-3" *ngIf="isMerchantEntity">
              <div class="col-12">
                <h6 class="mb-3">Optional Contract Documents</h6>
              </div>
              <ng-container *ngFor="let f of merchantContractFieldConfigs; trackBy: trackByFieldKey">
                <div class="col-sm-6">
                  <app-file-input
                    [label]="f.label" [required]="!!f.required" [control]="ctrl(form, f.key)"
                    [submitted]="isSubmitted" [accept]="f.accept || ''"
                    [uploadedFileName]="uploadedFileNames[f.uploadedFileKey || f.key]"
                    (fileChange)="onFieldFileChange($event, form, f)"
                    (view)="onFieldFileView(form, f)"
                    (remove)="onFieldFileRemove(form, f)"
                  ></app-file-input>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="isRegularMerchant">
              <div class="row">
                <ng-container *ngFor="let f of licenseDocFieldConfigs; trackBy: trackByFieldKey">
                  <div class="col-sm-6">
                    <ng-container [ngSwitch]="f.type">
                      <app-text-input
                        *ngSwitchCase="'number'"
                        type="number" [label]="f.label" [required]="!!f.required"
                        [control]="ctrl(regularGroup, f.key)" [submitted]="isSubmitted" [id]="f.key"
                      ></app-text-input>
                      <app-file-input
                        *ngSwitchCase="'file'"
                        [label]="f.label" [required]="!!f.required" [control]="ctrl(regularGroup, f.key)"
                        [submitted]="isSubmitted" [accept]="f.accept || ''"
                        [uploadedFileName]="uploadedFileNames[f.uploadedFileKey || f.key]"
                        (fileChange)="onFieldFileChange($event, regularGroup, f)"
                        (view)="onFieldFileView(regularGroup, f)"
                        (remove)="onFieldFileRemove(regularGroup, f)"
                      ></app-file-input>
                    </ng-container>
                  </div>
                </ng-container>
              </div>

              <h6 class="mt-4 mb-3">{{ shareholders.controls.length === 1 ? 'Personal Information' : 'Shareholder Information' }}</h6>
              <div class="border rounded p-3 mb-3" *ngFor="let sh of shareholders.controls; let i = index">
                <div class="text-muted small mb-2" *ngIf="shareholders.controls.length > 1">Shareholder {{ i + 1 }}</div>
                <div class="row">
                  <ng-container *ngFor="let f of shareholderFieldConfigs(i); trackBy: trackByFieldKey">
                    <div class="col-sm-6">
                      <ng-container [ngSwitch]="f.type">
                        <app-text-input
                          *ngSwitchCase="'text'"
                          [label]="f.label" [required]="!!f.required" [control]="ctrl(getShareholderGroup(i), f.key)"
                          [submitted]="isSubmitted" [id]="f.key + '_' + i" [maxlength]="f.maxlength || null"
                          [readonly]="f.readonly || false"
                        ></app-text-input>
                        <app-date-input
                          *ngSwitchCase="'date'"
                          [label]="f.label" [required]="!!f.required" [control]="ctrl(getShareholderGroup(i), f.key)"
                          [submitted]="isSubmitted" [id]="f.key + '_' + i" [min]="f.min || null" [max]="f.max || null"
                          (keydown)="f.preventKeyInput ? noKeyInput($event) : null"
                        ></app-date-input>
                        <app-select-input
                          *ngSwitchCase="'select'"
                          [label]="f.label" [required]="!!f.required" [control]="ctrl(getShareholderGroup(i), f.key)"
                          [submitted]="isSubmitted" [items]="f.items || []" [bindLabel]="f.bindLabel || 'text'"
                          [bindValue]="f.bindValue || ''" [placeholder]="'Select ' + f.label" [id]="f.key + '_' + i"
                        ></app-select-input>
                        <app-text-input
                          *ngSwitchCase="'percentage'"
                          type="number" [label]="f.label" [required]="!!f.required"
                          [control]="ctrl(getShareholderGroup(i), f.key)" [submitted]="isSubmitted"
                          [id]="f.key + '_' + i" placeholder="0-100"
                        ></app-text-input>
                        <app-file-input
                          *ngSwitchCase="'file'"
                          [label]="f.label" [required]="!!f.required" [control]="ctrl(getShareholderGroup(i), f.key)"
                          [submitted]="isSubmitted" [accept]="f.accept || ''"
                          [uploadedFileName]="uploadedFileNames[f.uploadedFileKey || f.key]"
                          (fileChange)="onFieldFileChange($event, getShareholderGroup(i), f)"
                          (view)="onFieldFileView(getShareholderGroup(i), f)"
                          (remove)="onFieldFileRemove(getShareholderGroup(i), f)"
                        ></app-file-input>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="isClientPro">
              <div class="row" *ngIf="form.get('clientProLevel')?.value">
                <div class="col-sm-6">
                  <div class="form-group mb-3">
                    <label class="form-label">Transaction Limit</label>
                    <div class="alert alert-info py-2 px-3 mb-0">
                      <strong>{{ transactionLimitDisplay }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <ng-container *ngFor="let f of clientProLocationFieldConfigs; trackBy: trackByFieldKey">
                  <div class="col-sm-6">
                    <ng-container [ngSwitch]="f.type">
                      <app-text-input
                        *ngSwitchCase="'text'"
                        [label]="f.label" [required]="!!f.required" [control]="ctrl(clientProGroup, f.key)"
                        [submitted]="isSubmitted" [id]="f.key" [placeholder]="f.placeholder || f.label"
                      ></app-text-input>
                      <app-select-input
                        *ngSwitchCase="'select'"
                        [label]="f.label" [required]="!!f.required" [control]="ctrl(clientProGroup, f.key)"
                        [submitted]="isSubmitted" [items]="f.items || []" [bindLabel]="f.bindLabel || 'text'"
                        [bindValue]="f.bindValue || ''" [placeholder]="'Select ' + f.label" [id]="f.key"
                      ></app-select-input>
                    </ng-container>
                  </div>
                </ng-container>
              </div>

              <div class="row" *ngIf="clientProPhotoFieldConfigs.length">
                <ng-container *ngFor="let f of clientProPhotoFieldConfigs; trackBy: trackByFieldKey">
                  <div class="col-sm-6">
                    <app-file-input
                      [label]="f.label" [required]="!!f.required" [control]="ctrl(clientProGroup, f.key)"
                      [submitted]="isSubmitted" [accept]="f.accept || ''"
                      [uploadedFileName]="uploadedFileNames[f.uploadedFileKey || f.key]"
                      (fileChange)="onFieldFileChange($event, clientProGroup, f)"
                      (view)="onFieldFileView(clientProGroup, f)"
                      (remove)="onFieldFileRemove(clientProGroup, f)"
                    ></app-file-input>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <div class="row" *ngIf="form.invalid && invalidFieldSummary.length">
            <div class="col-sm-12">
              <div class="alert alert-warning py-2 px-3 mt-3 mb-0">
                Please complete: {{ invalidFieldSummary.join(', ') }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="text-end mt-3">
                <button
                  *ngIf="permissions.includes('Add') || permissions.includes('Edit')"
                  class="btn bg-danger-custom" type="submit"
                  [disabled]="loading || form.invalid || phoneExists || checkingPhone"
                >
                  {{ loading ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
